import React from 'react';
import { TableRow, TableCell } from 'pvs-design-system';
import { Box } from '@mui/material';
import { SHIMMER_CONTENT_SX } from 'constants/styles';

interface TableSkeletonProps {
  rows?: number;
  colSpan?: number;
}

/** Shimmer placeholder rows rendered inside a <TableBody> while content loads. */
export const LibraryTableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 5, colSpan = 4 }) => (
  <>
    {Array.from({ length: rows }, (_, i) => (
      <TableRow key={i}>
        <TableCell colSpan={colSpan}>
          <Box sx={{ height: 40, borderRadius: 1, ...SHIMMER_CONTENT_SX }} />
        </TableCell>
      </TableRow>
    ))}
  </>
);

interface GridBarsSkeletonProps {
  rows?: number;
}

/** Padded stack of shimmer bars used for the grid view's loading state. */
export const LibraryGridBarsSkeleton: React.FC<GridBarsSkeletonProps> = ({ rows = 5 }) => (
  <Box sx={{ p: 3 }}>
    {Array.from({ length: rows }, (_, i) => (
      <Box key={i} sx={{ height: 48, borderRadius: 1, mb: 0.5, ...SHIMMER_CONTENT_SX }} />
    ))}
  </Box>
);
